<template>
    <div class="form-content">
        <div class="home-header">
          <headers :params="hraderP"></headers>
          <!-- <div class="mine">
            <div @click="nimeColor = true" :class="{'color1':nimeColor,'color2':!nimeColor}">自主提交</div>
            <div @click="nimeColor = false" :class="{'color1':!nimeColor,'color2':nimeColor}">一键提交</div>
          </div> -->
          <div class="mine">
            <div @click="nimeColor = true" :class="{'color1':nimeColor,'color2':!nimeColor}" style="margin: 5px 0 5px 8%;border-radius: 6px 0 0 6px;">自主提交</div>
            <div  @click="nimeColor = false" :class="{'color1':!nimeColor,'color2':nimeColor}" style="margin: 5px 8% 5px 0;border-radius: 0 6px 6px 0;">一键提交</div>
          </div>
        </div>
        <div style="height:60px;background: #EFEFF4;" v-if="!isNativeApp"></div>
        <div style="height: 2.7rem;background: #EFEFF4;" v-if="isNativeApp"></div>
        <div v-if="nimeColor">
          <oneclickSubmit></oneclickSubmit>
        </div>
        <div v-if="!nimeColor">
          <autonomous></autonomous>
        </div>

        <!-- 联系客服 -->
       <!-- <div class="const">
         <img src="../../assets/images/hema.png" >
         <div class="const-item">
           <p>联系客服</p>
           <p>帮您填写</p>
         </div>
       </div> -->
    </div>
</template>

<script>
import headers from '@/components/headerslf'
import wxAuth from '@/components/wxAuth'
import oneclickSubmit from '@/components/oneclickSubmit'
import autonomous from '@/components/autonomous'
export default {
  name: 'add-demand-form',
  components: { wxAuth, headers ,oneclickSubmit,autonomous},
  data () {
    return {
      hraderP: {
        title: '提交需求',
        lefticon: true
      },
      nimeColor:true,
      isNativeApp:false
    }
  },
  created(){
     this.isNativeApp = !(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.form-content{
  background: #FFF;
  padding-bottom: 20px;
  .home-header{
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9;
  }
  .h24{
    height: 2.7rem;
    background: #EFEFF4;
  }
  .const{
    position: fixed;
    right: 0;
    bottom: 110px;
    width: 68px;
    text-align: center;
    img{
      width: 40px;
      height: auto;
    }
    &-item{
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      font-size: 12px;
      padding: 4px 0;
    }
  }
  .mine{
    height:44px;
    width: 100%;
    background: #ffffff;
    display: flex;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    div{
      width: 42%;
      height: 70%;
      border: 1px solid #2F7BFF;
      line-height: 2;
    }
    .color1{
      color: #ffffff;
      background: #2F7BFF;
    }
    .color2{
      color: #2F7BFF;
      background: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/need/form.vue